/** Human-readable line for a Dexwork order (status or fallback fields). */
export function formatLeanCustomsOrderDetailLine(
  order: Record<string, unknown>
): string | null {
  for (const key of ["status", "order_status", "workflow_status", "state"]) {
    const value = order[key];
    if (typeof value === "string" && value.trim()) {
      return value.trim().replace(/_/g, " ");
    }
  }

  const parts: string[] = [];
  const ticket = order.ticket_number;
  if (ticket != null && String(ticket).trim()) {
    parts.push(`LC-${String(ticket).trim()}`);
  }

  const reference = order.reference ?? order.booking_number;
  if (typeof reference === "string" && reference.trim()) {
    parts.push(reference.trim());
  }

  const orderType = order.order_type;
  if (typeof orderType === "string" && orderType.trim()) {
    parts.push(orderType.trim());
  }

  const transportMode = order.transport_mode;
  if (typeof transportMode === "string" && transportMode.trim()) {
    parts.push(transportMode.trim());
  }

  const incoterm = order.incoterm_code ?? order.incoterm;
  if (typeof incoterm === "string" && incoterm.trim()) {
    parts.push(incoterm.trim());
  }

  return parts.length > 0 ? parts.join(" · ") : null;
}
